import React from "react";
import { ReactSVG } from "react-svg";

import arrowIcon from "../../assets/svg/arrow-s.svg";
import UIIcon from "../Common/UIIcon";
import AvatarUI from "./AvatarUI";
import { pressPoint } from "./glass";
import SearchBarUI from "./SearchBarUI";

const cx = (...a) => a.filter(Boolean).join(" ");
// evidențierea căutării: aceeași ca în toată aplicația (SearchBarUI.Highlight)
const highlight = (text, query) => <SearchBarUI.Highlight text={text} query={query} />;

/**
 * GroupItemUI — caseta unei grupe (Grupe): sus avatarul grupei, numele și cheia, cu săgeata în
 * dreapta (ca la StudentItemUI), dedesubt pastilele pe rânduri (profesorul · sectorul, managerul ·
 * membrii). Toată caseta se apasă (deschide grupa); editarea stă în grupa deschisă. Liquid Glass
 * pe casetă și pe pastile. Stilurile: scss/UI/_groupItemUI.scss.
 *
 * name · token (cheia, cu iconița cheii) · highlightQuery (evidențiază în nume, cheie, pastile)
 * rows: [[{ icon, label, title, grow? }, …], …] — pastilele, pe rânduri; grow: pastila se
 *    întinde (numele), altfel cât textul (sectorul, membrii)
 * onOpen: clic / Enter / Spațiu · chevron (implicit, cu onOpen) · className
 */
export default function GroupItemUI({ name, token, rows = [], highlightQuery = "", onOpen, chevron, className = "" }) {
   const interactive = typeof onOpen === "function";
   const showChevron = chevron ?? interactive;
   return (
      <div
         className={cx("groupItemUI", interactive && "is-interactive", className)}
         onClick={interactive ? onOpen : undefined}
         onPointerDown={interactive ? pressPoint : undefined}
         role={interactive ? "button" : undefined}
         tabIndex={interactive ? 0 : undefined}
         onKeyDown={
            interactive
               ? (e) => {
                    if (e.target !== e.currentTarget) return;
                    if (e.key === "Enter" || e.key === " ") {
                       e.preventDefault();
                       onOpen(e);
                    }
                 }
               : undefined
         }
         aria-label={interactive ? `Deschide grupa ${name}` : undefined}
      >
         <div className="groupItemUI__head">
            <AvatarUI name={name} size={null} className="groupItemUI__avatar" />
            <div className="groupItemUI__info">
               <h3 className="groupItemUI__name">{highlight(name, highlightQuery)}</h3>
               <p className="groupItemUI__token">
                  <UIIcon name="key" className="groupItemUI__tokenIcon" />
                  {highlight(token || "—", highlightQuery)}
               </p>
            </div>
            {showChevron ? (
               <span className="groupItemUI__chev" aria-hidden="true">
                  <ReactSVG src={arrowIcon} className="groupItemUI__chevIcon" />
               </span>
            ) : null}
         </div>

         {rows.map((row, r) => (
            <div key={r} className="groupItemUI__row">
               {row.filter(Boolean).map((pill, i) => (
                  <span key={i} className={cx("groupItemUI__pill", pill.grow && "is-grow")} title={pill.title}>
                     {pill.icon ? <UIIcon name={pill.icon} className="groupItemUI__pillIcon" /> : null}
                     <span className="groupItemUI__pillValue">{highlight(pill.label ?? "—", highlightQuery)}</span>
                  </span>
               ))}
            </div>
         ))}
      </div>
   );
}
